import { Link } from "react-router-dom";
import type { Article } from "@/mocks/content";

type Props = {
  article: Article;
  layout?: "grid" | "wide";
};

const categoryLabel: Record<Article["category"], string> = {
  "film-info": "电影资讯",
  "related-info": "相关资讯",
};

export default function ArticleCard({ article, layout = "grid" }: Props) {
  if (layout === "wide") {
    return (
      <Link
        to={`/detail/${article.id}`}
        className="group flex cursor-pointer flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row"
      >
        <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-32 sm:w-52">
          <img
            src={article.cover}
            alt={article.title}
            title={article.title}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2 text-xs">
            <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
              {categoryLabel[article.category]}
            </span>
            <span className="text-foreground-500">{article.type}</span>
          </div>
          <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
            {article.title}
          </h3>
          <p className="mt-1 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
          <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {(article.views / 1000).toFixed(1)}k
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${article.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-48 w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={article.title}
          title={article.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-800/85 px-2.5 py-1 text-xs font-medium text-background-50">
          {categoryLabel[article.category]}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
        <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(article.views / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </Link>
  );
}